<script>
import { gE, getTokenHeader } from "./lib/utils";
import MicroModal from "micromodal";

MicroModal.init();

const getOptions = (obj) => {
  return {
    onClose: obj.onClose,
  };
};

export default {
  emits: ["addedImage"],
  mounted() {
    const myDropzone = new Dropzone("form#upload-zone", { url: "upload" });
    const vu = this;
    myDropzone.on("sending", (file, xhr, formData) => {
      xhr.setRequestHeader("Authorization", getTokenHeader().Authorization);
    });
    myDropzone.on("addedfile", (file) => {
      vu.$emit("addedImage", file);
    });
  },
  data() {
    return {
      itemName: "",
      title: "",
      actionName: "",
      content: "",
      hasInput: false,
      userInput: "XXX",
      currentModal: false,
    };
  },
  methods: {
    logout() {
      this.$emit("logout");
    },
    onClose() {
      setTimeout(() => {
        this.currentModal = false;
      }, 200);
    },
    active() {
      return !!this.currentModal;
    },
    runConfirmation() {
      MicroModal.close(this.currentModal);
      if (this.hasPassword) {
        this._confirmation(this.userInput);
      } else {
        this._confirmation(this.hasInput ? this.userInput : undefined);
      }
    },
    hide() {
      if (this.currentModal) MicroModal.close(this.currentModal);
    },
    askUser(title, content, actionName, options, confirmAction) {
      this.currentModal = "modal-action";
      this._confirmation = confirmAction;
      this.title = title;
      this.content = content;
      this.actionName = actionName;
      let opts = options || {};
      this.hasInput = opts.hasInput;
      this.hasPassword = false;
      if (!this.hasInput) {
        this.hasPassword = opts.hasPassword;
      }
      this.userInput = "";
      MicroModal.show("modal-action", getOptions(this));
      if (this.hasInput || this.hasPassword) {
        setTimeout(() => {
          gE("input.userInput").focus();
        }, 300);
      }
    },
    showUploadForm() {
      this.currentModal = "modal-upload";
      MicroModal.show(this.currentModal, getOptions(this));
    },
    showHelp() {
      this.currentModal = "modal-help";
      MicroModal.show(this.currentModal, getOptions(this));
    },
  },
};
</script>
<style lang="scss">
@use 'variables' as vars;

.modal {
  z-index: 5;
  font-family: -apple-system, BlinkMacSystemFont, avenir next, avenir,
    helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif;
}

.modal__overlay {
  z-index: 4;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal__container {
  background-color: vars.$background-color;
  padding: 30px;
  max-width: 500px;
  max-height: 100vh;
  border-radius: 4px;
  overflow-y: auto;
  box-sizing: border-box;
}
.dark .modal__container {
  background-color: vars.$background-color-dark;
}

.modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal__title {
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.25;
  color: vars.$primary-color;
  box-sizing: border-box;
}

.modal__close {
  background: transparent;
  color: vars.$primary-color;
  border: 0;
}

.modal__header .modal__close:before {
  content: "\2715";
}

.modal__content {
  margin-top: 2rem;
  margin-bottom: 2rem;
  line-height: 1.5;
  color: vars.$front-color;
}
.dark .modal__content {
  color: vars.$front-color-dark;
}

.modal__btn {
  font-size: 0.875rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: darken(vars.$background-color, 20%);
  color: rgba(0, 0, 0, 0.8);
  border-radius: 0.25rem;
  border-style: none;
  border-width: 0;
  cursor: pointer;
  -webkit-appearance: button;
  text-transform: none;
  overflow: visible;
  line-height: 1.15;
  margin: 0 0.5ex;
  will-change: transform;
  -moz-osx-font-smoothing: grayscale;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  transition: -webkit-transform 0.25s ease-out;
  transition: transform 0.25s ease-out;
  transition: transform 0.25s ease-out, -webkit-transform 0.25s ease-out;
}
.dark .modal__btn {
  background-color: lighten(vars.$background-color-dark, 20%);
}

.modal__btn:focus,
.modal__btn:hover {
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}

.dark .modal__btn-primary {
  background-color: vars.$background2-color-dark;
  color: vars.$front-color-dark;
}
.modal__btn-primary {
  background-color: vars.$background2-color;
  color: vars.$front-color;
}

@keyframes mmfadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes mmfadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes mmslideIn {
  from {
    transform: translateY(15%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes mmslideOut {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-10%);
  }
}

.micromodal-slide {
  display: none;
}

.micromodal-slide.is-open {
  display: block;
}

.micromodal-slide[aria-hidden="false"] .modal__overlay {
  animation: mmfadeIn 0.3s cubic-bezier(0, 0, 0.2, 1);
}

.micromodal-slide[aria-hidden="false"] .modal__container {
  animation: mmslideIn 0.3s cubic-bezier(0, 0, 0.2, 1);
}

.micromodal-slide[aria-hidden="true"] .modal__overlay {
  animation: mmfadeOut 0.3s cubic-bezier(0, 0, 0.2, 1);
}

.micromodal-slide[aria-hidden="true"] .modal__container {
  animation: mmslideOut 0.3s cubic-bezier(0, 0, 0.2, 1);
}

.micromodal-slide .modal__container,
.micromodal-slide .modal__overlay {
  will-change: transform;
}

input.userInput {
  width: 100%;
  margin: 0 0 1em 0;
}
form#upload-zone {
  min-width: 400px;
  min-height: 400px;
}
</style>
<template>
<!-- FILE UPLOAD -->

<div class="modal micromodal-slide" id="modal-upload" aria-hidden="true">
  <div class="modal__overlay" tabindex="-1" data-micromodal-close>
    <div
      class="modal__container"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-1-title"
    >
      <header class="modal__header">
        <h2 class="modal__title" id="modal-1-title">Upload content</h2>
        <button
          class="modal__close"
          aria-label="Close modal"
          data-micromodal-close
        ></button>
      </header>
      <main class="modal__content" id="modal-1-content">
        <form action="upload" class="dropzone" id="upload-zone"></form>
      </main>
      <footer class="modal__footer">
        <button
          class="modal__btn"
          data-micromodal-close
          aria-label="Close this dialog window"
        >
          Close
        </button>
      </footer>
    </div>
  </div>
</div>
<!-- HELP -->

<div class="modal micromodal-slide" id="modal-help" aria-hidden="true">
  <div class="modal__overlay" tabindex="-1" data-micromodal-close>
    <div
      class="modal__container"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-1-title"
    >
      <header class="modal__header">
        <h2 class="modal__title" id="modal-1-title">Help</h2>
        <button
          class="modal__close"
          aria-label="Close modal"
          data-micromodal-close
        ></button>
      </header>
      <main class="modal__content" id="modal-1-content">
        <h3>Shortcuts</h3>
        <table>
          <tbody>
            <tr>
              <th>Key</th>
              <th>Description</th>
            </tr>
            <tr>
              <td><b>e</b></td>
              <td>Edit</td>
            </tr>
            <tr>
              <td><b>n</b></td>
              <td>New page</td>
            </tr>
            <tr>
              <td><b>f</b></td>
              <td>Find / Search</td>
            </tr>
            <tr>
              <td><b>escape</b></td>
              <td>Save (return to view mode)</td>
            </tr>
            <tr>
              <td><b>delete</b></td>
              <td>Delete this note</td>
            </tr>
            <tr>
              <td><b>backspace</b></td>
              <td>Toggle the side bar display</td>
            </tr>
            <tr>
              <td><b>left/right</b></td>
              <td>Navigate</td>
            </tr>
          </tbody>
        </table>
      </main>
      <footer class="modal__footer">
        <button
          class="modal__btn"
          data-micromodal-close
          aria-label="Close this dialog window"
        >
          Close
        </button>
        <button
          class="modal__btn"
          data-micromodal-close
          aria-label="Log out"
          @click.once="logout"
        >
          Log out
        </button>
      </footer>
    </div>
  </div>
</div>

<!-- Generic action -->

<div class="modal micromodal-slide" id="modal-action" aria-hidden="true">
  <div class="modal__overlay" tabindex="-1" data-micromodal-close>
    <div
      class="modal__container"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-1-title"
    >
      <header class="modal__header">
        <h2 class="modal__title" id="modal-1-title">{{title}}</h2>
      </header>
      <main class="modal__content" id="modal-1-content" v-html="content"></main>
      <input
        type="text"
        class="userInput"
        v-if="hasInput"
        v-model="userInput"
        v-on:keyup.enter="runConfirmation()"
      />
      <input
        type="password"
        class="userInput"
        v-if="hasPassword"
        v-model="userInput"
        v-on:keyup.enter="runConfirmation()"
      />
      <footer class="modal__footer">
        <button
          class="modal__btn modal__btn-primary"
          data-micromodal-close
          aria-label="Close this dialog window"
          @click="runConfirmation()"
        >
          {{actionName}}
        </button>
        <button
          class="modal__btn"
          data-micromodal-close
          aria-label="Close this dialog window"
        >
          Cancel
        </button>
      </footer>
    </div>
  </div>
</div>
</template>
